import type {Role} from "@project/application/access-administration";

import {getRoleQueryOptions} from "@project/application/access-administration";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {RolePage} from "./-page/role.page";
import {RolePending} from "./-page/role.pending";

export const Route = createFileRoute("/_app/user-management/users/roles/$roleId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  loader: ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getRoleQueryOptions(params.roleId)),
  pendingComponent: RolePending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) => (data as Role | undefined)?.name,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.roleById.id,
        values: {roleId: p["roleId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {roleId} = Route.useParams();

  return <RolePage roleId={roleId} />;
}
